@if (bizEntity()) {
    <!-- if you want to show parent and owner field then do this excludeParentAndOwner input false -->
  <app-form-biz-entity [bizEntity]="bizEntity()!" [isEditing]="isEditing" [excludeParentAndOwner]="false"
   (saveComplete)="OnSaveCompleted($event)"></app-form-biz-entity>
}
